<template>
    <div>
        <div class="addmember">
            <span class="mbtb">创建客户</span>
<!--            <i class="el-icon-close mbbt-icon" @click="guanbi"></i>-->
        </div>
        <div>
            <img src="../../assets/cjmb1.png" class="cjimg">
        </div>
        <div style="margin-top: 5px">
            <div class="kuang-item">
                <span>姓名</span>
                <el-input v-model="form.memberName" size="small" placeholder="请输入姓名" class="ki"></el-input>
            </div>
            <div class="kuang-item">
                <span>手机</span>
                <el-input v-model="form.phone" size="small" placeholder="请输入号码" class="ki"></el-input>
            </div>
            <div class="kuang-item">
                <span>生日</span>
                <div class="srdate1" @click="toShiJian('1')">{{form.srDate}}</div>
            </div>
            <div class="kuang-item">
                <span>性别</span>
                <div class="mb-sex">
                    <el-radio-group v-model="form.sex" style="margin-top: 20px;margin-left: 17px">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2" style="margin-left: -10px">女</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="kuang-item1">
                <span>进店渠道</span>
                <div class="srdate1" :class="{'active': qdName=='选择渠道'}" @click="toQd()">{{qdName}}</div>
            </div>
            <div class="kuang-item1">
                <span>会员权益</span>
                <div class="srdate1" @click="toQy()" :class="{'active': qyName=='选择权益'}">{{qyName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第一负责人</span>
                <div class="srdate1" :class="{'active': fName=='请选择'}" @click="toEmps('1')">{{fName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第二负责人</span>
                <div class="srdate1" :class="{'active': sName=='请选择'}" @click="toEmps('2')">{{sName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第三负责人</span>
                <div class="srdate1" :class="{'active': tName=='请选择'}" @click="toEmps('3')">{{tName}}</div>
            </div>
        </div>
        <div class="mb-btn">
            <van-button type="default" class="quedingbtn" @click="saveMember('1')">确定返回</van-button>
            <van-button type="default" class="quedingbtn" v-if="!addType" @click="saveMember('2')">确定并办理会员卡</van-button>
        </div>
        <van-popup v-model="sjShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    @confirm="queding"
                    @cancel="quxiao"
            />
        </van-popup>

        <van-popup v-model="qdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="进店渠道" @cancel="qdShow = false" :columns="qds" @confirm="qdConfirm"  />
        </van-popup>
        <van-popup v-model="qyShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="会员权益" @cancel="qyShow = false" :columns="qys" @confirm="qyConfirm"/>
        </van-popup>
        <van-popup v-model="empShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="负责人列表" @cancel="empShow = false" :columns="empNames" @confirm="empConfirm"/>
        </van-popup>
        <van-popup v-model="bkShow" position="bottom" lock-scroll closeable overlay :close-on-click-overlay="false" style="height: 100%;overflow:hidden;">
            <Bk v-if="bkShow" ref="bk" @gbBk="gbBk"  :memberId="memberId"/>
        </van-popup>
    </div>
</template>

<script>

    import {formatDate, getCookie} from "../../utils/auth";
    import Bk from "../customer/center/card";
    export default {
        components: {Bk},
        data() {
            return {
                deptId:'',
                token:'',
                form: {
                    memberName: '',
                    sex: 1,
                    phone: '',
                    srDate: formatDate(new Date(), 'yyyy-mm-dd'),
                    mbSource:'',
                    levelId:'',
                    oneId:'',
                    twoId:'',
                    threeId:'',
                },

                sjShow: false,
                dateType: '',
                minDate: new Date("1900-01-01"),
                currentDate: new Date(),

                qdName:'选择渠道',
                qdShow:false,
                qds:[
                    '自来','抖音','美团','小红书','私域商城'
                ],
                qdMap:{
                    '自来':0, '抖音':1, '美团':2, '小红书':3, '私域商城':5,
                },
                qyName:'选择权益',
                qyShow:false,
                qys:[],
                lvs:[],

                fName:'请选择',
                sName:'请选择',
                tName:'请选择',
                fEmps:[],
                sEmps:[],
                tEmps:[],
                empShow:false,
                empType:'',
                emps:[],
                empNames:[],

                member:{},
                memberId:false,
                bkShow:false,
            };
        },
        props:{
            addType:String
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
        },
        methods: {
            chushi(){
                this.qdName='选择渠道'
                this.qyName='选择权益'
                this.fName='请选择'
                this.sName='请选择'
                this.tName='请选择'
                this.form={
                    memberName: '',
                        sex: 1,
                        phone: '',
                        srDate: formatDate(new Date(), 'yyyy-mm-dd'),
                        mbSource:'',
                        levelId:'',
                        oneId:'',
                        twoId:'',
                        threeId:'',
                }
            },


            toShiJian(type) {
                this.dateType = type
                this.sjShow = true
            },

            toQd(){
                this.qdShow= true
            },
            qdConfirm(val){
                this.form.mbSource=this.qdMap[val]
                this.qdName=val
                this.qdShow= false
            },
            toQy(){
                this.qyShow= true
                this.getPlusList()
            },
            qyConfirm(val,index){
                let lv = this.lvs[index]
                this.qyName=lv.plusName
                this.form.levelId=lv.id
                this.qyShow= false
            },
            async getPlusList(){
                let res = await this.$get("/fw/getPlusLevels", {token:this.token});
                if (res.lvs){
                    res.lvs.forEach(item=>{
                        this.qys.push(item.plusName)
                    })
                    this.lvs=res.lvs
                }
            },

            toEmps(empType){
                this.empNames=[]
                this.emps=[]
               if (!this.empType){
                   this.getEmpList(empType)
               }else {
                   if (empType=='1'){
                           this.emps=this.fEmps
                           this.fEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
                   if (empType=='2'){
                           this.emps=this.sEmps
                           this.sEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
                   if (empType=='3'){
                           this.emps=this.tEmps
                           this.tEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
               }
                this.empShow= true
                this.empType=empType
            },
            empConfirm(val,index){
                if (this.emps.length>0){
                    let emp = this.emps[index]
                    if (this.empType=='1'){
                        this.fName=emp.nickName
                        this.form.oneId=emp.id
                    }
                    if (this.empType=='2'){
                        this.sName=emp.nickName
                        this.form.twoId=emp.id
                    }
                    if (this.empType=='3'){
                        this.tName=emp.nickName
                        this.form.threeId=emp.id
                    }
                }
                this.empShow= false
            },
            //获取员工列表
            async getEmpList(empType) {
                let res = await this.$get("/sw/getSwEmpList", {token: this.token});
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                if (empType=='1'){
                    this.emps=res.fEmps
                    res.fEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
                if (empType=='2'){
                    this.emps=res.sEmps
                    res.sEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
                if (empType=='3'){
                    this.emps=res.tEmps
                    res.tEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
            },

            async saveMember(type) {
                this.form.deptId = this.deptId
                let res = await this.$post("/fw/saveFwMember", this.form);
                if (res.code == 200) {
                    if (type == '1') {
                        this.fanhui(res.member)
                        this.$notify({type: 'success', message: res.message});
                    }
                    if (type == '2') {
                        this.addShow = false
                        // this.$router.push('/hycz?memberId='+res.member.id)
                        // this.$notify({type: 'success', message: res.message});
                        this.toBk(res.member)
                    }
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            toBk(item){
                this.memberId=item.id
                this.member=item
                this.bkShow=true
            },
            gbBk(){
                this.bkShow=false
                this.fanhui(this.member)
            },

            queding(val) {
                let date = formatDate(val, 'yyyy-mm-dd')
                this.form.srDate = date
                this.quxiao()
            },
            fanhui(member){
                this.$emit('gbMember',member)
            },
            quxiao() {
                this.sjShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>

    .cjimg{

    }

    .kuang-item {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        height: 50px;
        line-height: 60px;
    }
    .ki {
        width: 60%;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }
    .kuang-item1 {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        height: 50px;
        line-height: 60px;
    }
    .srdate1 {
        display: block;
        margin-left: 15.5px;
        text-align: right;
    }
    .active {
        color: #C0C4CC;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        cursor: not-allowed;
    }

    .mb-btn {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20%;
        margin-bottom: 20px;
    }
    .quedingbtn {
        width: 49%;
        text-align: center;
        height: 40px;
    }

</style>